module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Gritify AI":"Gritify AI"},"sv":{"Gritify AI":"Gritify AI"}}')
  delete Component.options._Ctor
}
